import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const deleteTenderItem = createAsyncThunk(
    "deleteTenderItem",
    async (itemId, { rejectWithValue }) => {
        try {
            const response = await axiosHttp.patch(`tms/tenders/items/${itemId}`, { reason: "deleted by user" });
            return response.data;
        } catch (err) {
            if (!err.response) throw err;
            return rejectWithValue(err.response.data);
        }
    }
);

const TenderItemDeleteSlice = createSlice({
    name: "TenderItemDeleteSlice",
    initialState: {
        isLoading: false,
        data: null,
        error: null,
    },
    reducers: {
        resetTenderItemDelete: (state) => {
            state.isLoading = false;
            state.data = null;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(deleteTenderItem.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(deleteTenderItem.fulfilled, (state, action) => {
                state.isLoading = false;
                state.data = action.payload;
            })
            .addCase(deleteTenderItem.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            });
    },
});

export const { resetTenderItemDelete } = TenderItemDeleteSlice.actions;
export default TenderItemDeleteSlice.reducer;
